import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';


import { SearchFilterMenuItem } from '@app/components/helpers/search/filters/models/filters-menu';
import { SearchAppliedFilter, SearchAvailableFilters } from '@app/models/search';
import { ApprovalsFiltersService, ApprovalsSearchService } from '@app/services/app/approvals.service';
import { AppService } from '@app/services/app/app.service';


import { ApprovalsAvailableFiltersStatus, FiltersHttpStatus } from '@app/store/state/approvals/approvals.state';

@Component({
  selector: 'approvals-search-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class ApprovalsSearchFiltersComponent implements OnInit {
  private readonly ACCESS_GLOBAL_APPROVALS = 'access_global_approvals';

  public readonly F_STATUS = FiltersHttpStatus;

  private wasInside: boolean = false;

  public selectedFilter: string = '';
  public approvalsAcces: string | boolean ;

  // menu
  public filtersMenu: Array<SearchFilterMenuItem> = [
    {
      title: 'Filter by Tag',
      key: 'label',
      order: 1
    }];
    
  public recipientsMenu: SearchFilterMenuItem = {
        title: 'Filter by Recipient',
        key: 'feedback_user',
        order: 2
  };
  public availableLabels: SearchAvailableFilters = null;
  // public availableRequestors: SearchAvailableFilters = null;
  public availableUsers: SearchAvailableFilters = null;
  public appliedFilters: SearchAppliedFilter[] = [];

  private labelsSubscription: Subscription;
  // private requestorSubscription: Subscription;
  private usersSubscription: Subscription;
  private appliedFiltersSubscription: Subscription;
  private accessSubscription: Subscription;
  private initializedFiltersSubscription: Subscription;
  private filterStatus: ApprovalsAvailableFiltersStatus;

  @HostListener('click')
  clickInside() {
      this.wasInside = true;
  }

  @HostListener('document:click')
  clickout() {
      if (!this.wasInside) {
          this.selectedFilter = '';
      }
      this.wasInside = false;
  }

  constructor(
    private filtersSrv: ApprovalsFiltersService, 
    private searchSrv: ApprovalsSearchService, 
    private appSrv: AppService ){}

  ngOnInit() {
    this.labelsSubscription = this.filtersSrv.selectLabels().subscribe((filter: SearchAvailableFilters) => this.availableLabels = filter);
    this.usersSubscription = this.filtersSrv.selectUsers().subscribe((filter: SearchAvailableFilters) => {
        this.availableUsers = filter;
    });

    this.appliedFiltersSubscription = this.searchSrv.selectFilters().subscribe((filters: SearchAppliedFilter[]) => this.appliedFilters = filters);

    /**
     * This check status of initialized filters in store. If by any case any load fails, is retried in 3 seconds with 2 attempts. 
     * when all atttempts are completed without success. A manual action item is displayed in the menu to manully load filters.
     * 
     */
    this.initializedFiltersSubscription = this.filtersSrv.selectFilterInitializedStatus().subscribe((fStatus: ApprovalsAvailableFiltersStatus) => {
        this.filterStatus = fStatus;
    });

    this.accessSubscription =  this.appSrv.getAccess(this.ACCESS_GLOBAL_APPROVALS).subscribe((access: string | boolean) => {
        this.approvalsAcces = access;
        this.updateMenu(this.recipientsMenu, this.approvalsAcces)
    })
  }

  ngOnDestroy() {
      this.labelsSubscription.unsubscribe();
      // this.requestorSubscription.unsubscribe();
      this.usersSubscription.unsubscribe();
      this.appliedFiltersSubscription.unsubscribe();
      this.accessSubscription.unsubscribe();
      this.initializedFiltersSubscription.unsubscribe();
  }

  onSelectFilter(key: string){
      this.selectedFilter = key;
  }

  onApplyFilter(filter: SearchAppliedFilter){
      // console.log("received filter isssss ",filter);
      this.searchSrv.applyFilter(filter);
  }

  loadUsers(){
      this.filtersSrv.loadUsersFilter();
  }

  loadLabels(){
    this.filtersSrv.loadLabelsFilter();
  }

  // to update filtesr menu according approvals access
  protected updateMenu(item: SearchFilterMenuItem, accessItem:boolean | string = true) {
    this.filtersMenu = this.filtersMenu.filter((i: SearchFilterMenuItem) => item.key != i.key);
    if(accessItem == null || accessItem == true ){
        this.filtersMenu.push(item);
    }
}


}
